import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  checkObjAuth(objId) {
    return axios.get(`${baseUrl}/common/mgr/check-obj-auth.do`, {
      params: { objId },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/common/mgr.js